import { Component, OnInit, TemplateRef } from '@angular/core';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { G_ManufactureViewModel } from 'src/app/viewmodels/g-settings/G_ManufactureViewModel';
import { NgxSpinnerService } from 'ngx-spinner';
import { SaveManufacturerRequest } from 'src/app/viewmodels/g-settings/GSettingViewModel';

@Component({
  selector: 'app-manufacturer',
  templateUrl: './manufacturer.component.html',
  styleUrls: ['./manufacturer.component.scss']
})
export class ManufacturerComponent implements OnInit {
  modalRef: BsModalRef;
  public itemVm: SaveManufacturerRequest = new SaveManufacturerRequest();
  public vmListItems: any = [];
  public component_Title = 'Manufecturer';
  public deleteId: string;

  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    private _modalService: BsModalService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.getList();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this._modalService.show(template);
  }

  ngAfterViewInit() {
  }

  getList() {
    this.spinner.show();
    this._uow.gSettingService.GetManufacturersAsync().subscribe((res: any) => {
      this._jq.reinitDataTable(res.result);
      this.vmListItems = res.result;
      console.log(res);
      this.spinner.hide();
    }, (err) => {
      console.log(err);
      this.spinner.hide();
    });
  }

  openSaveOrUpdateModel(template: TemplateRef<any>, model?) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
    } else {
      this.itemVm = new SaveManufacturerRequest();
    }
  }
  openDeleteModel(template: TemplateRef<any>, model) {
    this.openModal(template);
    if (model !== undefined) {
      this.itemVm = model;
      this.deleteId = model.uniqueId;
    }
  }

  conformDelete() {
    this._uow.gSettingService.DeleteManufacturerAsync(this.deleteId).subscribe((res: any) => {
      this.getList();
      this.modalRef.hide();
    }, (err) => {
      this._jq.showSpinner();
    });
  }
  // extrnal components
  onItemSubmitted(e) {
    console.log(e);
    if (e === true) {
      this.itemVm = new SaveManufacturerRequest();
      this.getList();
    }
  }
}
